import { z } from 'zod';

export const addressFormFieldSchema = z.object({
    addressNumber: z.string().optional().nullable(),
    alternate: z.string().optional().nullable(),
    country: z.string(),
    countryCode: z.string(),
    fullAddress: z.string(),
    latitude: z.number(),
    longitude: z.number(),
    mapboxId: z.string(),
    place: z.string(),
    postcode: z.string().optional().nullable(),
    region: z.string(),
    streetName: z.string().optional().nullable(),
});

export type AddressFormFieldData = z.infer<typeof addressFormFieldSchema>;
